import React, { Component } from 'react';
import { render } from 'react-dom';
import HcpCalcEditor from '../src/ace';

import 'delete-cus-race-aug/mode/jsx';
import 'delete-cus-race-aug/theme/monokai';
import 'delete-cus-race-aug/mode/hcpgrammar';
import 'delete-cus-race-aug/snippets/hcpgrammar';
import 'delete-cus-race-aug/ext/language_tools';
import { getAceInstance } from '../src/editorOptions';
import { HCPExpression } from '../src/HCPExpression';

render(<HcpCalcEditor />, document.getElementById('HCPCalcsEditor'));
